<template>
	<div class="videolist">
		<div class="breadcrumb">问卷列表</div>
		<div class="searchBtn" style="border:none;display:flex">
			<div class="topinput">
				<input type="text" v-model="searchValue" class="el-input__inner" placeholder="姓名/手机号" @keyup.enter="search_mine">
			</div>
		    <el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row  style="width: 100%">
		    <el-table-column prop="id" label="ID"></el-table-column>
		    <el-table-column prop="nickname" label="姓名"></el-table-column>
		    <el-table-column prop="phone" label="手机号"></el-table-column>
		    <el-table-column prop="province" label="省/自治区/直辖市"></el-table-column>
		    <el-table-column prop="city" label="市"></el-table-column>
		    <el-table-column prop="district" label="区/县"></el-table-column>
		    <el-table-column prop="address" label="详细地址"></el-table-column>
		    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  	mounted() {
  		this.init(); 	
  	},
  	data() {
    	return {
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tableData3: [],
    		searchValue:'',
	    };
  	},
  	methods:{
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		searchValue:this.searchValue,
      		};
      		this.$get("/questionnaire/queryQuestionnaire", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
  		},
  		//当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
  		search_mine(){
  			this.pageNum = 1;
	      	this.init()
  		}
	    
  	}
}
</script>
<style scoped>
.topinput{
	position: relative;
	margin-right: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/questionnaireList/index.vue